<template>
    <div>
        <div class="row fl-x fl-j-sb">
             <h2 class="head font-poppins-semibold fs-lg-4 mt-3 text-primary ml-3">Unit Transfer</h2>
             <div class="row fl-j-e mr-3 mt-3">
                 <div class="mr-1"><btn class="btn btn-sm  border-r-1 bordered p-1" style="cursor: pointer" @click="AddRecord">Add Unit Transfer</btn></div>
                 <div><btn class="btn btn-sm  border-r-1 bordered p-1" style="cursor: pointer" @click="BackToHome">Back</btn></div>
             </div>
        </div>
        <vue-table ref="table" :fields="fields" :url="listURL" :per-page="10">

            <template slot="actions" slot-scope="props">
                <div class="btn-group">
                    <btn text="" size="sm" icon="fa fa-pencil" color="primary"
                         @click="editItem(props.rowData)"/>
                    <btn text="" size="sm" icon="fa fa-trash" color="danger"
                         @click="deleteItem(props.rowData.id)"/>
                </div>

            </template>
        </vue-table>
        <modal ref="editRecord" :no-close-on-backdrop="true" title="Edit Disposal" header-color="primary">
            <s-form @submit="EditRecord">
                <div class="row">
                    <validated-input label="Date Of Transfer" :rules="{required: true}"
                                         class="col-4" border-radius="1" v-model="editingItem.date_of_transfer" disabled></validated-input>
                    <validated-input label="Register No" :rules="{required: true}"
                                         class="col-4" border-radius="1" v-model="editingItem.reg_no" disabled></validated-input>
                    <validated-input label="UID Number"
                                         class="col-4" border-radius="1" v-model="editingItem.uid" disabled></validated-input>
                    <validated-input label="Registration Type"
                                         class="col-4" border-radius="1" v-model="editingItem.registration_type" disabled></validated-input>
                    <validated-input label="Source"
                                         class="col-4" border-radius="1" v-model="editingItem.source" disabled></validated-input>
                    <validated-input label="From Unit"
                                         class="col-4" border-radius="1" v-model="editingItem.from_unit" :rules="{required: true}" ></validated-input>
                    <validated-input label="To Unit"
                                         class="col-4" border-radius="1" v-model="editingItem.to_unit" :rules="{required: true}"></validated-input>
                    <validated-input label="Remarks" class="col-8" border-radius="1" v-model="editingItem.remarks"></validated-input>

                </div>
                    <div class="col-12 text-right mt-4">
                        <btn type="submit" text="Save" :loading="editLoading" class="px-4"></btn>
                    </div>

            </s-form>
        </modal>

        <delete-modal ref="deleteModal" :no-close-on-backdrop="true" enter-animation="animated slideInDown" exit-animation="animated slideOutUp" :url="deleteURL" :params="{id : itemID}"
                      @response="deleteComplete">
            <p> Are you sure ?</p>
            <template #loading>
                <div class="fl-x">
                    <loading-animation/>
                    <b class="ml-3">Please Wait...</b>
                </div>
            </template>
        </delete-modal>

</div>

</template>
<script>
import axios from 'secure-axios';
import urls from '../../data/urls';

export default {
    name: 'UnitTransferList',
    data () {
        return {
            viewData: [],
            currentPage: 1,
            itemsPerPage: 10,
            loadingData: false,
            listURL: urls.unit_transfer.list,
            deleteURL: urls.unit_transfer.delete,
            itemID: null,
            editLoading: false,
            editStatus: false,
            editingItem: {
                id: null,
                is_bull: null,
                is_cow: null,
                reg_no: null,
                animal_id: null,
                date_of_transfer: null,
                uid: null,
                registration_type: null,
                source: null,
                from_unit: null,
                to_unit: null,
                remarks: null
            },
            fields: [
                {
                    name: 'date_of_transfer',
                    sortField: 'date_of_transfer',
                    title: 'Date of Transfer'
                },
                {
                    name: 'reg_no',
                    sortField: 'reg_no',
                    title: 'Register No'
                },
                {
                    name: 'from_unit',
                    sortField: 'from_unit',
                    title: 'From Unit'
                },
                {
                    name: 'to_unit',
                    sortField: 'to_unit',
                    title: 'To Unit'
                },
                {
                    name: '__slot:actions',
                    title: 'Actions'
                }
            ],
            rules: {
                positiveOnly: {
                    customValidator (value) {
                        return value < 0 ? 'Please enter a valid number' : true;
                    }
                }
            }

        };
    },

    methods: {
        editItem (item) {
            console.log('edit-item:>>>:', item);
            this.editStatus = true;
            this.editingItem.id = item.id;
            this.editingItem.is_bull = item.is_bull;
            this.editingItem.is_cow = item.is_cow;
            this.editingItem.reg_no = item.reg_no;
            this.editingItem.animal_id = item.animal_id;
            this.editingItem.date_of_transfer = item.date_of_transfer;
            this.editingItem.uid = item.uid;
            this.editingItem.source = item.source;
            this.editingItem.registration_type = item.registration_type;
            this.editingItem.from_unit = item.from_unit;
            this.editingItem.to_unit = item.to_unit;
            this.editingItem.remarks = item.remarks;
            this.$refs.editRecord.show();
        },
        BackToHome () {
            this.$router.push({ path: '/general/' });
        },
        deleteItem (item) {
            this.itemID = item;
            this.$refs.deleteModal.show();
        },
        deleteComplete (response) {
            const data = response.data || response;
            console.log(data);
            if (data.success === true) {
                this.$notify(
                    data.message || 'Deleted Successfully',
                    'Success',
                    { type: 'success' }
                );
                this.$refs.table.refreshTable();
            } else {
                this.$notify(
                    data.message || 'Unable to delete record',
                    'Warning',
                    { type: 'warning' }
                );
            }

            this.$refs.deleteModal.close();
        },
        AddRecord () {
            this.$router.push({ path: '/unit-transfer/' });
        },
        async EditRecord () {
            this.editLoading = true;
            console.log('Inside Edit------------------');

            try {
                const response = await axios.form(urls.unit_transfer.addEdit, this.editingItem);
                const result = response.data;

                if (result.success) {
                    this.$notify(
                        result.message || 'Updated Successfully',
                        'Success',
                        { type: 'success' }
                    );

                    if (result.errors) {
                        const errors = result.errors;

                        for (const key in errors) {
                            if (Object.prototype.hasOwnProperty.call(errors, key)) {
                                let errorMessage = '';

                                if (key === '__all__') {
                                    errorMessage = `${errors[key]}`;
                                } else {
                                    errorMessage = `${key}: ${errors[key]}`;
                                }

                                this.$notify(
                                    errorMessage,
                                    'Warning',
                                    { type: 'warning' }
                                );
                            }
                        }
                    }

                    this.$refs.editRecord.close();
                    this.$refs.table.refreshTable();
                } else {
                    this.$notify(
                        result.message || 'Unable to update record',
                        'Warning',
                        { type: 'warning' }
                    );
                }
            } catch (error) {
                this.$notify(
                    'Something Went Wrong..!!',
                    error.response.status + ' ' + error.response.statusText,
                    { type: 'danger' }
                );
            } finally {
                this.editLoading = false;
            }
        }
    }
};

</script>
<style>
table {
        background-color: #f3f3f3;
        text-align: center;
    }

    th {
        background-color: white;
        border: 0px;
        padding-top: 0.9rem;
        padding-bottom: 0.9rem;
        padding-left: 18px;
        text-align: center;
    }

    td {
        padding-left: 18px;
        padding-top: 0.8rem;
        padding-bottom: 0.8rem;
    }

    table, td, tr {
        border: none;
        border-collapse: collapse;
    }

    table, th, tr {
        border-radius: 4px;

    }
</style>
